import { createFileRoute } from '@tanstack/react-router'
import { ChatHistoryList } from '../../../../components/ChatHistory'

export const Route = createFileRoute('/platform/desa/$desaId/riwayat')({
  component: () => {
    const { desaId } = Route.useParams()
    return <ChatHistoryList desaId={desaId} />
  },
})
